import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import { green } from '@mui/material/colors';
import api from '../../api/api';



const AllUsersList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.get('/api/users/chat/userslist/');
        setUsers(response.data);
      } catch (error) {
        console.error('Failed to fetch users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
    const interval = setInterval(fetchUsers, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {users.map((user) => (
        <Grid item xs={12} sm={6} md={4} key={user.id}>
          <Card variant="outlined">
            <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
              <Box position="relative" mr={2}>
                <Avatar
                  src={user.profile_image}
                  alt={user.full_name}
                  sx={{ width: 56, height: 56 }}
                />
                {user.is_online && (
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      backgroundColor: green[500],
                      border: '2px solid white',
                    }}
                  />
                )}
              </Box>
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">
                  {user.full_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {user.role}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AllUsersList;
